var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.frequencyUpdatePermission)?_c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[(_vm.frequency !== null)?_c('frequency-edit-tab',{attrs:{"dataFrequency":_vm.frequency}}):_vm._e()],1)],1):_c('not-permission')
}
var staticRenderFns = []

export { render, staticRenderFns }